/* eslint-disable no-unused-expressions */
import { useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components";
import Head from "next/head";
import Link from "next/link";
import useTrackWebSession from "hooks/useTrackWebSession";
import { getJobListingRoute, isHostLaunchedMicrosite } from "utils";
import { MICROSITES } from "utils/constants";
import { getGlobalCSSVariants } from "theme";
import Layout from "../components/Layout/Layout";
import { Section, Container } from "../styles/commonStyles";
import Button from "../components/Buttons/Button";
import Mixpanel from "../utils/Mixpanel";
import { mediaMaxWidth } from "../utils/mediaQuery";
import { getUrlPath } from "../utils/helpers";
import TagManagerUtils from "../utils/TagManager";

const GlobalStyles = createGlobalStyle`
    footer {
        padding-top: 15px !important;
    }
`;

export default function Apna404Page() {
	const pageName = "404 Page";
	const hostVendor = isHostLaunchedMicrosite();
	const isHostVendorVi = hostVendor ? hostVendor === MICROSITES.VI : false;
	const cssVariant = getGlobalCSSVariants();
	useEffect(() => {
		Mixpanel.track("404 Page View", {
			page: getUrlPath(),
			Source: pageName,
		});

		TagManagerUtils.addDataLayer({
			Source: pageName,
		});
	}, []);
	useTrackWebSession(pageName);

	return (
		<>
			<GlobalStyles />
			<Layout
				title="Page not found"
				hideStatsBanner
				hideStickyFooter
				hideCustomerLogosSection
				is404
				disableIndexing
			>
				<Head>
					<meta name="robots" content="noindex, follow" />
				</Head>
				<Section>
					<MainContainer>
						<TextContainer>
							<Text>4</Text>
							<ImageContainer>
								<Image
									src="https://cdn.apna.co/cloudinary/404.png"
									alt="404"
									loading="lazy"
								/>
							</ImageContainer>
							<Text>4</Text>
						</TextContainer>
						<div />
						<DescriptionContainer>
							<DescriptionHeading>OOPS!</DescriptionHeading>
							<DescriptionText>
								Looks like the page you&#39;re looking for doesn&#39;t
								exist
							</DescriptionText>
							<ButtonGroup>
								{isHostVendorVi ? (
									<Link href={getJobListingRoute()} passHref>
										<div
											className="mr-[16px] h-[40px] flex-1 cursor-pointer rounded-[4px] border px-[16px] pb-[12px] pt-[8px] text-[14px] font-[600]"
											style={{
												color: cssVariant.primaryColor,
												borderColor: cssVariant.primaryColor,
											}}
										>
											Go back to Jobs
										</div>
									</Link>
								) : (
									<Button
										as="a"
										link
										href="/"
										onClick={() => {
											Mixpanel.track(
												"404 Page Go Home Button Click",
												{
													page:
														typeof window !== "undefined" &&
														window.location.href,
												}
											);
										}}
									>
										Go Home
									</Button>
								)}
								{isHostVendorVi ? (
									<Link href="/contact-us" passHref>
										<div
											className="h-[40px] flex-1 cursor-pointer rounded-[4px] px-[16px] pb-[12px] pt-[8px] text-[14px] font-[600] text-[#fff]"
											style={{
												background: cssVariant.primaryColor,
											}}
										>
											Contact Us
										</div>
									</Link>
								) : (
									<Link href="/contact-us" passHref>
										<Button
											secondary
											onClick={() => {
												typeof window !== "undefined" &&
													window.Intercom &&
													window.Intercom("show");
												Mixpanel.track(
													"404 Page Contact Us Button CLick",
													{
														page:
															typeof window !==
																"undefined" &&
															window.location.href,
													}
												);
											}}
										>
											Contact Us
										</Button>
									</Link>
								)}
							</ButtonGroup>
						</DescriptionContainer>
					</MainContainer>
				</Section>
			</Layout>
		</>
	);
}

// Styles
const ImageContainer = styled.div``;
const Image = styled.img`
	max-width: 200px;
	margin: 0 30px;
`;
const TextContainer = styled.div`
	margin: 80px auto 30px;
	display: flex;
	align-items: center;
	justify-content: center;
`;
const Text = styled.h1`
	font-size: 200px;
	margin: 0;
	color: rgba(77, 57, 81, 0.3);
`;
const DescriptionContainer = styled.div`
	text-align: center;
	margin-bottom: 50px;
`;
const DescriptionHeading = styled.h3`
	margin: 0 0 15px;
	font-size: 24px;
	font-weight: 900;
	color: #373737;
`;
const DescriptionText = styled.p`
	margin: 0;
	font-size: 18px;
	line-height: 1.44;
	color: #6a6a6a;
`;
const ButtonGroup = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	max-width: 350px;
	margin: 25px auto;

	& a,
	& button {
		height: 40px;
		line-height: 40px;
		padding: 0 25px;
		font-size: 17px;
	}
`;
const MainContainer = styled(Container)`
	${mediaMaxWidth.small`
        ${Text} {
            font-size: 92px;
        }
        ${Image} {
            max-width: 100px;
        }
    `}
`;
